import React, { Component } from "react";
import { Button } from "react-bootstrap";
import { numberWithCommas } from "../../utils/common";
import "./InvoiceItem.scss";

class InvoiceItem extends Component {
  render() {
    const {
      period,
      planName,
      userCount,
      amount,
      invoiceUrl
    } = this.props;

    return (
      <div className="invoice-item d-flex justify-content-between align-items-end">
        <div className="period">{period}</div>
        <div className="planName">Plan: {planName}</div>
        <div className="userCount">Users: {userCount}</div>
        <div className="amount">USD {numberWithCommas((Number(amount)/100).toFixed(2))}</div>
        <Button variant="outline-danger" size="sm" onClick={this.props.onClick}>
          <a href={invoiceUrl} download>DOWNLOAD</a>
        </Button>
      </div>
    );
  }
}

export default InvoiceItem;
